import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';

const Login = () => import('@/pages/Login/index.vue');
const LoginVerify = () => import('@/pages/Login/Verify.vue');
const Appbar = () => import('@/components/Appbar.vue');
const HeaderBack = () => import('@/components/Header/Back.vue');
const FluctuantHeader = () => import('@/components/Header/Fluctuant.vue');
const Activity = () => import('@/pages/Activity/index.vue');
const ConsolidatedAssessment = () => import('@/pages/Assessment/index.vue');
const AssessmentStats = () => import('@/pages/Assessment/AssessmentStats.vue');
const AssessmentReview = () =>
  import('@/pages/Assessment/AssessmentReview/index.vue');
const OnConversation = () =>
  import('@/pages/Conversation/onConversation/index.vue');
const ForceUpdate = () => import('@/pages/ForceUpdate.vue');
const Home = () => import('@/pages/Home/index.vue');
const Welcome = () => import('@/pages/Welcome/index.vue');
const ProductDiscovery = () =>
  import('@/pages/Onboarding/ProductDiscovery/index.vue');
const SocialProof = () => import('@/pages/Onboarding/SocialProof/index.vue');
const UserDataCollection = () =>
  import('@/pages/Onboarding/UserDataCollection/index.vue');
const PostPurchase = () => import('@/pages/Onboarding/PostPurchase/index.vue');
const OnboardingForm = () => import('@/pages/OnboardingForm/index.vue');
const Profile = () => import('@/pages/Profile/index.vue');
const ProfileCertificates = () => import('@/pages/Profile/Certificates.vue');
const Summary = () => import('@/pages/Summary/index.vue');
const Ranking = () => import('@/pages/Ranking/index.vue');
const Redirect = () => import('@/pages/Redirect.vue');
const Settings = () => import('@/pages/Settings/index.vue');
const SettingsAccount = () => import('@/pages/Settings/Account.vue');
const SettingsInterests = () => import('@/pages/Settings/Interests.vue');
const SettingsReferral = () => import('@/pages/Settings/Referral.vue');
const SettingsPurchases = () => import('@/pages/Settings/Purchases.vue');
const SettingsReminders = () => import('@/pages/Settings/Reminders.vue');
const SettingsVoices = () => import('@/pages/Settings/Voices.vue');
const ThankYou = () => import('@/pages/ThankYou.vue');
const Conversation = () => import('@/pages/Conversation/index.vue');
const PlacementTest = () => import('@/pages/PlacementTest/index.vue');
const PlacementTestResult = () => import('@/pages/PlacementTest/Result.vue');
const BeTeacher = () => import('@/pages/BeTeacher/index.vue');
const UserWrapped2024 = () => import('@/pages/Wrapped/2024/index.vue');
const Paywall = () => import('@/pages/Paywall/index.vue');
const Back = () => import('@/components/Header/Back.vue');
const Certificate = () => import('@/pages/Certificate/index.vue');
const Streak = () => import('@/pages/UserStreak/index.vue');
const AssessmentFeedback = () =>
  import('@/pages/Assessment/Feedback/index.vue');
const ConversationResult = () =>
  import('@/pages/Conversation/Result/index.vue');

import { tracking } from '@/helpers/track-event';
import NotFound from '@/pages/NotFound.vue';
import { useAppStore } from '@/store/app';
import { useAuthStore } from '@/store/auth';

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'welcome',
    components: {
      default: Welcome,
    },
    meta: {
      auth: false,
    },
  },
  {
    path: '/auth',
    name: 'auth',
    components: {
      default: Redirect,
    },
    meta: {
      auth: false,
    },
    props: true,
  },
  {
    path: '/login',
    name: 'Login',
    components: {
      default: Login,
    },
    meta: {
      auth: false,
    },
    props: true,
  },
  {
    path: '/login/verify',
    name: 'LoginVerify',
    components: {
      default: LoginVerify,
    },
    meta: {
      auth: false,
    },
    props: true,
  },
  {
    path: '/thank-you',
    name: 'thank-you',
    components: {
      default: ThankYou,
    },
    meta: {
      auth: false,
    },
    props: true,
  },
  {
    path: '/update',
    name: 'update',
    components: {
      default: ForceUpdate,
    },
    meta: {
      auth: false,
    },
    props: true,
  },
  {
    path: '/onboarding/product-discovery',
    name: 'onboarding-product-discovery',
    components: {
      default: ProductDiscovery,
    },
    meta: {
      auth: false,
    },
    props: true,
  },
  {
    path: '/onboarding/social-proof',
    name: 'onboarding-social-proof',
    components: {
      default: SocialProof,
    },
    meta: {
      auth: false,
    },
    props: true,
  },
  {
    path: '/onboarding/user-data-collection',
    name: 'onboarding-user-data-collection',
    components: {
      default: UserDataCollection,
    },
    meta: {
      auth: false,
    },
    props: true,
  },
  {
    path: '/placement-test/:id',
    name: 'placemenTestResult',
    components: {
      default: PlacementTestResult,
    },
    meta: {
      auth: true,
    },
    props: true,
  },
  {
    path: '/onboarding/post-purchase',
    name: 'onboarding-post-purchase',
    components: {
      default: PostPurchase,
    },
    meta: {
      auth: false,
    },
    props: true,
  },
  {
    path: '/onboarding/invite',
    name: 'onboarding-invite',
    components: {
      default: OnboardingForm,
    },
    meta: {
      auth: false,
      transition: 'slide-in',
    },
    props: true,
  },
  {
    path: '/onboarding',
    name: 'onboarding-form-parent',
    components: {
      default: OnboardingForm,
    },
    meta: {
      auth: false,
    },
    props: true,
  },
  {
    path: '/onboarding/:step',
    name: 'onboarding-form-steps',
    components: {
      default: OnboardingForm,
    },
    meta: {
      auth: false,
      transition: 'slide-in',
    },
    props: true,
  },
  {
    path: '/onboarding/finished',
    name: 'onboarding-form-finished',
    components: {
      default: OnboardingForm,
    },
    meta: {
      auth: false,
    },
    props: true,
  },

  {
    path: '/home',
    name: 'home',
    components: {
      header: FluctuantHeader,
      default: Home,
      navigation: Appbar,
    },
    meta: {
      auth: true,
      title: 'Home',
    },
    props: true,
  },

  {
    path: '/settings',
    name: 'settings',
    components: {
      header: HeaderBack,
      default: Settings,
    },
    meta: {
      title: 'Ajustes e configurações',
      auth: true,
    },
    props: true,
  },

  {
    path: '/settings/app',
    name: 'settings-app',
    components: {
      header: HeaderBack,
      default: Settings,
    },
    meta: {
      title: 'Ajustes e configurações',
      auth: true,
    },
    props: true,
  },

  {
    path: '/settings/referral',
    name: 'settings-referral',
    components: {
      default: SettingsReferral,
      navigation: Appbar,
    },
    meta: {
      title: 'Programa de indicações',
      auth: true,
    },
    props: true,
  },

  {
    path: '/settings/whatsapp',
    name: 'settings-whatsapp',
    components: {
      header: HeaderBack,
      default: Settings,
    },
    meta: {
      title: 'Ajustes e configurações',
      auth: true,
    },
    props: true,
  },

  {
    path: '/profile',
    name: 'profile',
    components: {
      header: HeaderBack,
      default: Profile,
      navigation: Appbar,
    },
    meta: {
      title: 'Configurações',
      auth: true,
    },
    props: true,
  },
  {
    path: '/profile/certificates',
    name: 'certificates',
    components: {
      header: HeaderBack,
      default: ProfileCertificates,
      navigation: Appbar,
    },
    meta: {
      title: 'Certificados',
      auth: true,
    },
    props: true,
  },
  {
    path: '/settings/account',
    name: 'settings-account',
    components: {
      header: HeaderBack,
      default: SettingsAccount,
    },
    meta: {
      title: 'Meus dados pessoais',
      transition: 'slide-in',
      auth: true,
    },
    props: true,
  },

  {
    path: '/settings/interests',
    name: 'settings-interests',
    components: {
      header: HeaderBack,
      default: SettingsInterests,
    },
    meta: {
      title: 'Meus interesses',
      transition: 'slide-in',
      auth: true,
    },
    props: true,
  },

  {
    path: '/settings/reminders',
    name: 'settings-reminders',
    components: {
      header: HeaderBack,
      default: SettingsReminders,
    },
    meta: {
      title: 'Configuração de Lembretes',
      transition: 'slide-in',
      auth: true,
    },
    props: true,
  },

  {
    path: '/settings/voices',
    name: 'settings-voices',
    components: {
      header: HeaderBack,
      default: SettingsVoices,
    },
    meta: {
      title: 'Alterar voz e velocidade',
      transition: 'slide-in',
      auth: true,
    },
    props: true,
  },

  {
    path: '/settings/purchases',
    name: 'settings-purchases',
    components: {
      header: HeaderBack,
      default: SettingsPurchases,
    },
    meta: {
      title: 'Convites para ativar',
      transition: 'slide-in',
      auth: true,
    },
    props: true,
  },

  {
    path: '/conversation',
    name: 'conversation',
    components: {
      default: Conversation,
      navigation: Appbar,
    },
    meta: {
      auth: true,
    },
    props: true,
  },

  {
    path: '/conversation/:conversationId',
    name: 'onConversation',
    components: {
      default: OnConversation,
    },
    meta: {
      transition: 'slide-in',
      auth: true,
    },
    props: true,
  },

  {
    path: '/conversation/:conversationId/result',
    name: 'conversationResult',
    components: {
      default: ConversationResult,
    },
    meta: {
      transition: 'slide-in',
      auth: true,
    },
    props: true,
  },

  {
    path: '/ranking',
    name: 'ranking',
    components: {
      default: Ranking,
      navigation: Appbar,
    },
    meta: {
      auth: true,
    },
    props: true,
  },
  {
    path: '/be-teacher',
    name: 'be-teacher',
    components: {
      default: BeTeacher,
      navigation: Appbar,
    },
    meta: {
      auth: true,
    },
    props: true,
  },

  {
    path: '/activity/:id',
    name: 'activity',
    components: {
      default: Activity,
    },
    meta: {
      title: 'Atividade',
      transition: 'slide-in',
      auth: true,
    },
    props: true,
  },
  {
    path: '/consolidated-assessment/:id',
    name: 'consolidatedAssessment',
    components: {
      default: ConsolidatedAssessment,
    },
    meta: {
      title: 'Relatório',
      transition: 'slide-in',
      auth: true,
    },
  },
  {
    path: '/consolidated-assessment/overview/:id',
    name: 'overviewAssessment',
    components: {
      header: Back,
      default: AssessmentStats,
    },
    meta: {
      title: 'Revisão - Visão Geral',
      transition: 'slide-in',
      auth: true,
    },
  },
  {
    path: '/consolidated-assessment/interactions/:id/:type',
    name: 'AssessmentReview',
    components: {
      header: Back,
      default: AssessmentReview,
    },
    props: {
      header: { showReportBug: true },
    },
    meta: {
      title: 'Revisão',
      transition: 'slide-in',
      auth: true,
    },
  },
  {
    path: '/placement-test',
    name: 'placement-test',
    components: {
      default: PlacementTest,
    },
    meta: {
      auth: true,
    },
    props: true,
  },
  {
    path: '/wrapped/2024',
    name: 'wrapped',
    components: {
      default: UserWrapped2024,
    },
    meta: {
      auth: true,
    },
    props: true,
  },
  {
    path: '/paywall',
    name: 'paywall',
    components: {
      default: Paywall,
    },
    meta: {
      auth: false,
    },
  },
  {
    path: '/redirect',
    name: 'redirect',
    components: {
      default: Redirect,
    },
    meta: {
      auth: false,
    },
  },
  {
    path: '/certificate/:id',
    name: 'certificate',
    components: {
      default: Certificate,
    },
    meta: {
      auth: true,
    },
    props: true,
  },
  {
    path: '/streak',
    name: 'streak',
    components: {
      default: Streak,
    },
    meta: {
      auth: true,
    },
  },
  {
    path: '/summary/:period/:id',
    name: 'summary',
    components: {
      default: Summary,
    },
    meta: {
      auth: true,
    },
    props: true,
  },
  {
    path: '/assessment/:entityType/:entityId/feedback',
    name: 'assessment-feedback',
    components: {
      default: AssessmentFeedback,
    },
    meta: {
      auth: true,
    },
  },
  { path: '/:pathMatch(.*)*', name: 'not-found', component: NotFound },
];

const router = createRouter({
  history: createWebHistory(),

  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }

    return { left: 0, top: 0 };
  },
  routes,
});

router.beforeEach(async (to, from, next) => {
  tracking.onRouteChange(to, from);

  const authStore = useAuthStore();
  const appStore = useAppStore();
  const isAuthenticated = Boolean(authStore.token);
  const needsUpdate = Boolean(appStore.needsUpdate);

  const homePagePath = appStore.homePagePath;

  if (needsUpdate && to.name !== 'update') {
    return next({
      path: '/update',
    });
  }

  if (!from.name && to.path === '/' && isAuthenticated) {
    return next({
      path: homePagePath,
    });
  }

  if (to.meta && to.meta.auth) {
    if (isAuthenticated) {
      return next();
    }

    const isScreenshotAuthentication =
      to.query.token && to.query.kind === 'screenshot';

    // Do not use `isScreenshot()` function here, because the route is not yet loaded
    if (isScreenshotAuthentication) {
      authStore.setToken(to.query.token as string);

      return next();
    }

    return next({
      path: '/',
    });
  }

  return next();
});

router.afterEach((to, from) => {
  const toRoutePath = to.path.split('/').filter((str) => str); // removing empty strings in URL
  const fromRoutePath = from.path.split('/').filter((str) => str);

  const isSameBaseRoute = toRoutePath.at(0) === fromRoutePath.at(0);

  to.meta.transition =
    isSameBaseRoute && toRoutePath.length < fromRoutePath.length
      ? 'slide-out'
      : to.meta.transition;
});

export default router;
